import {
  Alert,
  AlertType,
  Dialog,
  DialogMaxWidth,
  DialogVariant,
  Text,
  TextHighlight,
  TextSize
} from '@focaldata/cin-ui-components'
import DragAndDropContextComponent from '../../../components/DragAndDrop-react-dnd/DragAndDropContext'
import useStyles from './ReorderAudienceDialog.styles'
import ReorderAudienceRow from './ReorderAudienceRow'

export const REORDER_SCROLL_CONTAINER_ID = 'reorderAudienceList'

export interface ReorderAudienceRowData {
  memberId: string
  label: string | undefined
  text: string
}

interface Props {
  open: boolean
  rows: ReorderAudienceRowData[]
  presetName?: string
  onClose: () => void
  onMove: (memberId: string, toIndex: number) => void
}

const ReorderAudienceDialogControl = ({
  open,
  rows,
  presetName,
  onClose,
  onMove
}: Props) => {
  const { classes } = useStyles()

  return (
    <Dialog
      title="Reorder audience questions"
      open={open}
      fullWidth
      maxWidth={DialogMaxWidth.Sm}
      variant={DialogVariant.SingleButton}
      primaryButtonText="Done"
      primaryButtonClick={onClose}
      onClose={onClose}
    >
      <div className={classes.intro}>
        <Text size={TextSize.ms} highlight={TextHighlight.Background}>
          Drag a question to change the order respondents answer them in. This
          market only — other markets keep their own order.
        </Text>
      </div>
      {presetName && (
        <Alert severity={AlertType.WARNING} style={{ marginBottom: 16 }}>
          {`This market uses the preset audience “${presetName}”. Changing the order switches it to a custom audience.`}
        </Alert>
      )}
      {/* Own scrolling box: drag auto-scroll needs an element that overflows. */}
      <div id={REORDER_SCROLL_CONTAINER_ID} className={classes.list}>
        <DragAndDropContextComponent>
          {rows.map((row, index) => (
            <ReorderAudienceRow
              key={row.memberId}
              memberId={row.memberId}
              index={index}
              label={row.label}
              text={row.text}
              scrollContainerSelector={`#${REORDER_SCROLL_CONTAINER_ID}`}
              onMove={onMove}
            />
          ))}
        </DragAndDropContextComponent>
      </div>
    </Dialog>
  )
}

export default ReorderAudienceDialogControl
